export enum IntegrationType {
  Integration = "integration",
  SDK = "sdk",
  SSO = "sso",
  SCIM = "scim",
  BWDC = "bwdc",
  EVENT = "event",
  DEVICE = "device",
}
